export const REFERRER_API_URL = {
  origin: import.meta.env.DEV
    ? import.meta.env.VITE_REFERRER_ORIGIN
    : document.referrer
      ? new URL(document.referrer).origin
      : '',
  hostname: import.meta.env.DEV
    ? import.meta.env.VITE_REFERRER_HOSTNAME
    : document.referrer
      ? new URL(document.referrer).hostname
      : '',
};
